<template>
	<div 
		class="next-step" 
		v-if="step <= 4 && status != 'archive' && nextSteps[step] != null && permissions[nextSteps[step].requiredPermission] !== false"
		:class="{
			'warning': nextSteps[step].treatmentPlanDeadline && countdownDate(nextSteps[step].treatmentPlanDeadline) < 0
		}"
		>

		<div class="info-block">
			<div class="icon warning" v-if="nextSteps[step].treatmentPlanDeadline && countdownDate(nextSteps[step].treatmentPlanDeadline) < 0">
				<i class="fal fa-exclamation-circle"></i>
			</div>
			<div class="icon" v-else>
				<i class="fal fa-info-circle"></i>
			</div>
			<div class="info-text">
				<div class="title" v-if="step == 4">Design Complete</div>
				<div class="title" v-else>Your Next Step</div>
				<div class="action-text" v-html="nextSteps[step].text" />
			</div>
		</div>

		<div class="action-block" v-if="nextSteps[step].buttonRoute">
			<div class="treatment-plan-deadline" v-if="nextSteps[step].treatmentPlanDeadline && countdownDate(nextSteps[step].treatmentPlanDeadline) >= 0">
				<strong>{{ countdownDate(nextSteps[step].treatmentPlanDeadline) }}</strong> days until approval deadline
			</div>
			<div class="treatment-plan-deadline" v-if="nextSteps[step].treatmentPlanDeadline && countdownDate(nextSteps[step].treatmentPlanDeadline) < 0">
				<strong>{{ countdownDate(nextSteps[step].treatmentPlanDeadline) * -1 }}</strong> days overdue approval deadline
			</div>
			<Button
				:label="nextSteps[step].buttonText"
				:color="nextSteps[step].treatmentPlanDeadline && countdownDate(nextSteps[step].treatmentPlanDeadline) < 0 ? 'red' : 'blue'"
				size="large"
				icon="chevron-double-right"
				:buttonRoute="nextSteps[step].buttonRoute"
				/>
		</div>


		<div class="action-block time-slot" v-if="nextSteps[step].implant_production_date != null && nextSteps[step].implant_production_date != 'Invalid date' && step == 4">
			<div class="info">
				<span>Your scheduled delivery:</span>
				<span>
					<strong>{{ formatDate(nextSteps[step].implant_production_date) }}</strong>
				</span>
			</div>
			<div class="icon">
				<i class="fal fa-rocket" />
			</div>
		</div>

	</div>
</template>

<script>

import Button from "@/Components/Button"
import moment from 'moment'

export default {
	components: {
		Button
	},
	props: [
		'step',
		'caseID',
		'status',
		'thisCase',
		'permissions'
	],
	data: () => {
		return {
			nextSteps: {
				0: {
					text: 'Please now upload your enquiry',
					buttonText: 'Upload Enquiry',
					buttonRoute: ``,
					requiredPermission: 'canUploadEnquiry'
				},
				1: {
					text: 'Please now upload your imagery',
					buttonText: 'Upload Images',
					buttonRoute: ``,
					requiredPermission: 'canUploadProjectImages'
				},
				2: {
					text: 'Please now schedule your design meeting',
					buttonText: 'Schedule Meeting',
					buttonRoute: ``,
					requiredPermission: 'canViewDesignMeeting'
				},
				3: {
					text: 'You need to review and approve your Treatment Plan',
					buttonText: 'Review Treatment Plan',
					buttonRoute: ``,
					requiredPermission: 'canApproveDenyTreatmentPlan'
				},
				4: {
					text: 'Your implant production has been queued!'
				}
			}
		}
	},
	mounted(){
		this.nextSteps[0].buttonRoute = `/cases/${this.caseID}/upload-enquiry`
		this.nextSteps[1].buttonRoute = `/cases/${this.caseID}/image-submission`
		this.nextSteps[2].buttonRoute = `/cases/${this.caseID}/design-meeting`
		this.nextSteps[3].buttonRoute = `/cases/${this.caseID}/review-treatment-plan`

		if(this.step == 2 && this.status != 'accepted'){
			this.nextSteps[2] = {
				text: 'Your case is under review. Check back soon to find out design meeting details.',
				requiredPermission: 'canViewDesignMeeting'
			}
		}
		if(this.step == 2 && this.status == 'accepted' && this.thisCase.design_meeting_details == null){
			this.nextSteps[2] = {
				text: 'Check back soon to find design meeting details.',
				requiredPermission: 'canViewDesignMeeting'
			}
		}

		this.nextSteps[3] = null
		

		if(this.step == 2 && this.thisCase.design_meeting_details != null){ // time slot is in future
			let extraDetails = '<br/><br/>'+this.linkify(this.thisCase.design_meeting_details)

			this.nextSteps[2] = {
				text: 'Please attend your design meeting.'+extraDetails,
				requiredPermission: 'canViewDesignMeeting'
			}
		}

		if(this.thisCase.override_progress == 3 || this.step == 3){ 
			if(this.thisCase.treatment_plan_deadline != null){
				this.nextSteps[3] = {
					text: 'You need to review and approve your Treatment Plan',
					buttonText: 'Review Treatment Plan',
					buttonRoute: `/cases/${this.caseID}/review-treatment-plan`,
					treatmentPlanDeadline: this.thisCase.treatment_plan_deadline,
					requiredPermission: 'canApproveDenyTreatmentPlan'
				}
			}else{
				this.nextSteps[3] = {
					text: 'Your treatment plan is being worked on. You will receive a notification when you can review it.',
					requiredPermission: 'canApproveDenyTreatmentPlan'
				}
			}
		}
		if(this.step == 3 && this.thisCase.treatment_plan_approved == 'rejected'){
			this.nextSteps[3] = null
		}

		if(this.step == 4 && this.thisCase.implant_production_date != null){
			this.nextSteps[4].implant_production_date = this.thisCase.implant_production_date
		}

		// if(this.step == 4 && this.isInPast(this.thisCase.implant_production_date, '00:00')){
		//   this.nextSteps[4] = null
		// }

	},
	methods: {
		formatDate(inputDate) {
			if(inputDate != null && inputDate != '' && inputDate != 'Invalid date'){
				return moment(inputDate).format('D MMMM YYYY')
			}else{
				return 'TBC'
			}
		},
		isInPast(inputDate, inputTime){
			if(inputDate != null){
				let d = new Date(),
					month = '' + (d.getMonth() + 1),
					day = '' + d.getDate(),
					year = d.getFullYear(),
					hours = d.getHours(),
					minutes = d.getMinutes();

				hours = ("0" + hours).slice(-2);
				minutes = ("0" + minutes).slice(-2);
				day = ("0" + day).slice(-2);
				month = ("0" + month).slice(-2);

				let splitDate = inputDate.split('-').join('')
				let splitTime = inputTime.split(':').join('')

				if(parseInt(splitDate + splitTime) <= parseInt(String(year)+String(month)+String(day) + String(hours)+String(minutes))){
					return true
				}else{
					return false
				}
			}else{
				return false
			}
		},
		countdownDate(targetDate){
			let countDownDate = new Date(targetDate).getTime()
			let now = new Date().getTime()

			// Find the distance between now and the count down date
			let distance = countDownDate - now

			// Time calculations for days, hours, minutes and seconds
			let days = Math.floor(distance / (1000 * 60 * 60 * 24))

			return days+1
		},
		linkify(inputText) {
			let replacedText, replacePattern1, replacePattern2, replacePattern3;

			//URLs starting with http://, https://, or ftp://
			replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
			replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

			//URLs starting with "www." (without // before it, or it'd re-link the ones done above).
			replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
			replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

			//Change email addresses to mailto:: links.
			replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
			replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

			return replacedText;
		}
	}
}

</script>

<style lang="sass">

.next-step
	width: 100%
	border-radius: 8px
	padding: 22px
	display: flex
	align-items: center
	justify-content: space-between
	border: 2px solid #70C2FF
	overflow: hidden
	min-height: 70px
	background-color: #fff
	margin-bottom: 30px

	@media (max-width: 768px)
		flex-direction: column
		align-items: flex-start
		gap: 15px

	.info-block
		display: flex
		align-items: center


		.icon
			color: #70C2FF
			font-size: 45px
			display: flex
			align-items: center
			margin-right: 15px

			&.warning
				color: #f00

			@media (max-width: 768px)
				font-size: 30px

		.info-text
			.title
				color: #252525
				font-family: 'Roboto Condensed', sans-serif
				font-weight: 700
				font-size: 24px
				line-height: 1
				margin-bottom: 6px

				@media (max-width: 768px)
					font-size: 20px

			.action-text
				color: #252525
				font-family: 'Roboto Condensed', sans-serif
				font-weight: 400
				font-size: 18px
				line-height: 1.1

				@media (max-width: 768px)
					font-size: 16px

				a
					color: #70C2FF
					font-weight: 700
					transition: all 300ms

					&:hover
						color: darken(#70C2FF, 10%)

	.action-block
		display: flex
		align-items: center

		@media (max-width: 768px)
			flex-direction: column
			align-items: flex-start
			gap: 10px

		&.time-slot
			display: flex
			align-items: center
			justify-content: flex-end
			text-align: right

			.info
				display: flex
				flex-direction: column
				font-size: 18px

				@media (max-width: 768px)
					font-size: 16px

				strong
					font-weight: 700
			
			.icon
				width: 50px
				height: 50px
				display: flex
				align-items: center
				justify-content: flex-end
				margin-left: 10px

				.fal
					font-size: 45px
					color: #70C2FF

				@media (max-width: 768px)
					width: 30px
					height: 30px

					.fal
						font-size: 30px

		.treatment-plan-deadline
			margin-right: 15px
			font-size: 18px

			@media (max-width: 768px)
				font-size: 16px

	&.warning
		border-color: #f00



</style>